<template>
  <div>

    <el-button v-for="item in buttonList" :icon="item.icon" :type="item.type" :disabled="item.hasPriv" plain
      size="small" :key="item.title" @click="xx(item)">{{ item.title }}</el-button>
    <el-dialog v-dialogDrag :title=abc.title :visible.sync="approveWindow">
      <div style="height:300px;position:relative;">
        <div class="table-list">
          <span class="list-key">{{ $t('message.title.comments') }}</span>
          <span class="list-cc">:</span>
          <span class="list-val" style="float:left;">
            <el-input :style="input_width" :autosize="{ minRows: 9, maxRows: 12 }" type="textarea" :rows="1"
              :placeholder="$t('message.placeholder.input')" v-model="signoffComments">
            </el-input>
          </span>
        </div>
        <div class="table-list tableBtn">
          <el-button @click="approveChange()" size="small">{{ abc.title }}</el-button>
          <el-button @click="approveWindow = false" size="small">{{ $t('message.button.cancel') }}</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- {{ StatusBtn }} -->

    <span :class="{ 'disabled-cursor': this.StatusBtn }">
      <el-dropdown split-button size="small" style="margin-left:10px" @command="goToState">

        <div :disabled='StatusBtn' style="cursor: pointer;">
          <span size="small" :class="{ 'disabled-click': this.StatusBtn }" @click="NextState">
            {{ $t('message.title.manualNextStatus') }}
          </span>
        </div>

        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="status in statusInfo" :key="status.id" :statusType="status.statusType"
            :command="status" :disabled="hasPrivs(status)">
            {{ status.name }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <!-- <el-dropdown split-button size="small" :class="{ 'disabled-click': this.StatusBtn }" style="margin-left:10px"
        @click="NextState" @command="goToState">
        {{ $t('message.title.manualNextStatus') }}
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="status in statusInfo" :key="status.id" :statusType="status.statusType"
            :command="status">{{ status.name }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown> -->
    </span>
    <slot></slot>
    <el-dialog v-dialogDrag :title="$t('message.title.checkStatus')" :visible.sync="mandatoryField" width="42%"
      :before-close="auditClose" class="audit">
      <div v-show="audit_dialog">
        <div style="padding: 0 20px 10px 20px;">
          <div style="font-size: 20px;font-weight: bold;color: #000;">{{ $t('message.title.checkResult') }}
          </div>
          <div style="font-size: 16px;color: #000;"><b>{{ workflowInfo.name }} • </b>{{ workflowInfo.description }}
          </div>
        </div>
        <div style="font-size: 16px;background: #ffc8ca;padding: 10px 20px;color: #000;">
          <span style="position: relative;top: 2px;margin: 0 10px 0 0;">
            <img src="@/assets/change/warning.png" alt="">
          </span>
          <!-- 存在下列问题。必须先解决所有错误，然后状态才能变更为 {{nextStatusText}}。如果只存在警告，则可以继续。 -->
          {{ $t('message.tips.workflow_101') + nextItem.name + $t('message.tips.workflow_102') }}
        </div>
        <div style="padding: 10px 20px 0 20px;" v-if="audit_dialog_error">
          <span style="font-size: 20px;color: #000;">{{ $t('message.title.error') }}:</span>
          <ul style="list-style: disc;padding-top: 0;">
            <li v-for="item in audit_erro" style="color: red;font-size: 16px;" :key="item.index">
              {{ item }}</li>
          </ul>
        </div>
        <div style="padding: 0 20px 0 20px;" v-if="audit_dialog_warning">
          <span style="font-size: 20px;color: #000;">{{ $t('message.title.warning') }}:</span>
          <ul style="list-style: disc;padding-top: 0;">
            <li v-for="item in audit_warning" style="color: #f7a420;font-size: 16px;" :key="item.index">
              {{ item }}</li>
          </ul>
        </div>
      </div>

      <div v-show="audit_add">
        <div style="padding: 0 20px 10px 20px;">
          <div style="font-size: 20px;font-weight: bold;color: #000;">
            {{ $t('message.title.changeStatusTo') + nextItem.name }}</div>
          <div style="font-size: 16px;color: #000;"><b>{{ workflowInfo.name }} • </b>{{ workflowInfo.description }}
          </div>
        </div>
        <div style="font-size: 16px;background: #d4e8fd;padding: 10px 20px;color: #000;">
          <span style="position: relative;top: 4px;margin: 0 10px 0 0;">
            <img src="@/assets/change/info.png" alt="">
          </span>
          {{ $t('message.tips.workflow_103') }}
        </div>

        <div class="table-list" style="margin-top: 20px;">
          <span class="list-key">{{ $t('message.title.approver') }}</span>
          <span style="margin: 0 6px;line-height:40px;float:left">:</span>
          <span class="list-val" style="float:left;" :style="input_width2">
            <el-select :disabled="!addApproverPriv" size="small" :style="input_width" v-model="approvers" multiple
              filterable remote @change="change1" :placeholder="$t('message.placeholder.input')"
              :remote-method="remoteMethod" :loading="loading">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"
                :disabled="item.disabled">
              </el-option>
            </el-select>
          </span>
          <el-button :disabled="!addApproverPriv" type="primary" style="float:left;" size="small"
            @click="openSearchApproverWindow">
            {{ $t('message.button.search') }}</el-button>
        </div>

        <div class="table-list">
          <span class="list-key">{{ $t('message.title.observer') }}</span>
          <span style="margin: 0 6px;line-height:40px;float:left">:</span>
          <span class="list-val" style="float:left;" :style="input_width2">
            <el-select :disabled="!addApproverPriv" size="small" :style="input_width" v-model="notify" multiple
              filterable remote @change="change2" :placeholder="$t('message.placeholder.input')"
              :remote-method="remoteMethod2" :loading="loading">
              <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value"
                :disabled="item.disabled">
              </el-option>
            </el-select>
          </span>
          <el-button :disabled="!addApproverPriv" type="primary" style="float:left;" size="small"
            @click="openNotifyWindow">
            {{ $t('message.button.search') }}</el-button>
        </div>

        <div class="table-list" style="margin-bottom: 20px;">
          <span class="list-key">{{ $t('message.title.comments') }}</span>
          <span style="display: inline-block;margin: 0 6px;line-height:95px;float:left">:</span>
          <span class="list-val" style="float:left;">
            <el-input :style="input_width3" :autosize="{ minRows: 4, maxRows: 6 }" type="textarea" :rows="2"
              :placeholder="$t('message.placeholder.input')" v-model="textarea">
            </el-input>
          </span>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <div v-if="audit_dialog">
          <el-button type="primary" size="small" @click="NextState">{{ $t('message.title.check') }}</el-button>
          <el-button type="success" size="small" @click="nextStatusBtnClick" :disabled="nextStatusBtn">
            {{ $t('message.button.next') }}</el-button>
          <el-button size="small" @click="mandatoryField = false; audit_add = false">{{ $t('message.button.cancel') }}
          </el-button>
        </div>

        <div v-if="audit_add">
          <el-button type="success" @click="submit" size="small">{{ $t('message.title.finish') }}</el-button>
          <el-button @click="mandatoryField = false; audit_add = false" size="small">{{ $t('message.button.cancel') }}
          </el-button>
        </div>
      </span>

    </el-dialog>
    <el-dialog v-dialogDrag v-if="reviewersAddList" class="reviewersAddDialog" :title="$t('message.title.addApprover')"
      :visible.sync="reviewersAddList" :before-close="reviewersHandleClose">
      <searchAddUsers :userGroupLists1="userGroupLists" :projectWorkflowSubClassId="projectWorkflowSubClassId"
        @listDbClick="addApprover"></searchAddUsers>
    </el-dialog>

    <el-dialog v-dialogDrag v-if="notifyAddList" class="notifyAddDialog" :title="$t('message.title.addObserver')"
      :visible.sync="notifyAddList" :before-close="notifyHandleClose">
      <searchAddUsers :userGroupLists1="userGroupLists" :projectWorkflowSubClassId="projectWorkflowSubClassId"
        @listDbClick="addObserver"></searchAddUsers>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import searchAddUsers from "@/components/searchAddUsers.vue";
import { dialogDrag } from '@/utils/directive'
import Vue from "vue";
Vue.directive('dialogDrag', dialogDrag);

export default {
  name: 'workflowButton',
  data() {
    return {
      buttonList: [
        { icon: 'el-icon-check', type: 'primary', hasPriv: false, title: this.$t("message.title.approve"), id: 1 },
        { icon: 'el-icon-close', type: 'danger', hasPriv: false, title: this.$t("message.title.reject"), id: 0 }
      ],
      statusInfo: [],

      abc: {
        dialogTitle: '',
        buttonTitle: '',
        id: ''
      },

      StatusBtn: false,
      approveWindow: false,
      signoffComments: '',
      currentInfo: {
        id: '',
        loginId: ''
      },
      objectId: {
        ...this.$store.state.objectId
      },
      reviewersAddList: false, //添加窗口开关
      notifyAddList: false, //添加窗口开关


      updateWrokflowNum: 1,
      updateWorkflowTable: '',

      input_width: {
        width: "96%",
      },
      input_width2: {
        width: "50%",
      },
      input_width3: {
        width: "80%",
      },

      addApproverPriv: false,

      loading: false,

      currentStatus: {},
      nextStatus: {},
      user: [],
      userLists: [],
      userGroupLists: [],
      allInfo: {},
      textarea: '',
      mandatoryField: false,

      options: [],
      options2: [],
      approvers: [],
      notify: [],
      nextStatusBtn: true,
      audit_add: false,
      audit_dialog_error: false,
      audit_dialog_warning: false,
      fullscreenLoading: false,
      audit_dialog: false,
      audit_warning: ["WARNING1", "WARNING2", "WARNING3"],
      audit_erro: ["ERROR1", "ERROR2", "ERROR3"],
      nextItem: {},
      projectWorkflowSubClassId: "",

    }
  },
  components: { searchAddUsers },
  props: ['workflowInfo'],
  watch: {
    workflowInfo: function (val) {
      console.log(val);
      if (!val.workflowId) {
        this.StatusBtn = true
      }
      if (JSON.stringify(val) != "{}" && val.workflowId) {
        this.getData()
      }
    }
  },
  methods: {

    hasPrivs(item) {
      return item.hasPriv != 1
    },

    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.options = this.userLists.filter((item) => {
            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
          });
        }, 200);
      } else {
        this.options = [];
      }
    },
    remoteMethod2(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.options2 = this.userLists.filter((item) => {
            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
          });
        }, 200);
      } else {
        this.options2 = [];
      }
    },
    change1() {
      this.options = [];
    },
    change2() {
      this.options2 = [];
    },


    NextState() {
      console.log(this.statusInfo);
      if (this.StatusBtn) {
        return false;
      } else {
        //this.fullscreenLoading = true;
        this.textarea = "";
        this.nextItem = this.nextStatus;
        // this.nextStatusText = this.nextStatusTextVal;
        // this.title_nextStatusType = this.nextStatusType_old;
        this.getAudit(this.allInfo);
      }
    },

    goToState(item) {
      //console.log(this.statusInfo);
      console.log('==============', item);
      if (JSON.stringify(item) == '{}') {
        return
      }
      this.nextItem = item;
      const obj = {
        currentStatus: this.currentStatus.id,
        currentStatusType: this.currentStatus.statusType,
        nextStatus: item.id,
        nextStatusType: item.statusType,
        workflowId: this.currentStatus.workflowId
      }
      this.getAudit(obj);
      //console.log(command);
    },
    auditClose() {
      this.mandatoryField = false;
      this.audit_add = false;
    },
    nextStatusBtnClick() { },
    getAudit(item) {
      this.projectWorkflowSubClassId = this.$store.state.objectId.subClassId;
      const loading = this.$loading({
        lock: true,
        text: "正在验证状态，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      console.log(item);

      if (!item.nextStatus || (!item.nextStatusType && item.nextStatusType !== 0)) {
        loading.close();
        this.$message.error('当前没有下一状态');
        return
      }

      const _obj = {
        ...this.objectId,
        ...item,
      }
      axios.post('/pqm/quality/checkPathStatus', _obj).then(res => {
        // console.log(res);
        const { codeId, error, warning } = res.data.object;
        // console.log(res.data.object);
        if (codeId == 20004) {
          loading.close();
          this.audit_dialog = true;
          this.mandatoryField = true;

          this.audit_dialog_error = !!error.length;
          this.audit_add = !error.length;
          this.audit_erro = error.map(i => i.msg);
          //console.log(this.audit_erro);
          this.audit_dialog_warning = !!warning.length;
          this.nextStatusBtn = !error.length;
        }
        if (codeId == 200) {
          loading.close();
          if ([2, 3].includes(this.nextItem.statusType)) {
            this.audit_dialog = false;
            this.mandatoryField = true;
            this.audit_add = true;
            this.loadUser(item);
          } else {
            this.submitAudit(item);
          }
        }
      })
    },
    submit() {
      this.submitAudit(this.nextItem)
    },
    submitAudit(item) {
      console.log('111111', item);
      const obj = {
        approvers: [],
        observers: [],
        status: item.id,
        ...this.objectId,
        // ...this.allInfo,
        currentStatus: this.currentStatus.id,
        currentStatusType: this.currentStatus.statusType,
        nextStatus: this.nextItem.id,
        nextStatusType: this.nextItem.statusType,
        workflowId: this.currentStatus.workflowId,
        comments: this.textarea
      }
      console.log(this.userLists);
      if ([2, 3].includes(item.statusType)) {
        obj.approvers = this.userLists.filter(i => this.approvers.includes(i.value)).map(i => ({ id: i.value, loginId: i.loginId, type: 1 }));
        obj.observers = this.userLists.filter(i => this.notify.includes(i.value)).map(i => ({ id: i.value, loginId: i.loginId, type: 2 }));
      }
      for (var m = 0; m < obj.approvers.length; m++) {
        for (var n = 0; n < obj.observers.length; n++) {
          if (obj.approvers[m].id == obj.observers[n].id) {
            this.$message.error(this.MessageInfo.e_203);
            return false;
          }
        }
      }
      this.statusChange(obj);
    },
    statusChange(obj) {
      axios.post('/pqm/quality/changeWorkflowStatus', obj).then(res => {
        if (res.data.code == 200) {
          this.$message.success(res.data.message);
          this.loading = false;
          this.mandatoryField = false;
          this.checkUsrHasARPriv();
          this.$emit('setPageRefresh')
        }
      })
    },
    async getUserList(item) {
      // console.log(this.nextStatus);
      let subclassId = this.objectId.subClassId
      const obj = {
        ...this.objectId,
        // statusId: this.nextStatus.id,
        statusId: item.nextStatus
      }
      const SignoffUser = await axios.get(`/pqm/quality/queryNextStatusPathSignoff${this.params(obj)}`)
      const ApproveUser = await axios.get(`/pmdm/admin/user/getApproveUserList?privType=16` + "&subclassId=" + subclassId);
      return { SignoffUser, ApproveUser }
    },

    loadUser(item) {
      this.getUserList(item).then(res => {
        console.log(res);
        this.approvers = [];
        this.notify = [];
        const { users, usersGroups } = res.ApproveUser.data.object;
        this.userLists = users.map(i => ({ value: i.id, label: i.loginId + "(" + i.userName + ")", disabled: i.authTag != 1, loginId: i.loginId }))
        this.userGroupLists = usersGroups?.map(i => ({ value: i.id, label: i.loginId + "(" + i.userName + ")", disabled: i.authTag != 1, loginId: i.loginId })) || []
        const { comments, approveUserList, observerUserList } = res.SignoffUser.data.object;
        this.textarea = comments;
        this.options = approveUserList.map(i => {
          this.approvers.push(i.id);
          return {
            value: i.id,
            label: i.loginId + "(" + i.userName + ")"
          }
        })
        this.options2 = observerUserList.map(i => {
          this.notify.push(i.id);
          return {
            value: i.id,
            label: i.loginId + "(" + i.userName + ")"
          }
        })
      })
    },
    // updateUsers(){},

    xx(e) {
      this.abc = e;
      this.enableApproveWindow()
    },
    enableApproveWindow() {
      var user = [{
        ...this.currentInfo,
        type: 1,
      }];
      var checkChangeRequest = {
        objectId: { ...this.objectId },
        status: +this.workflowInfo.currentStatusId,
        user
      };
      axios
        .post("/pqm/quality/checkApproveRejectUser", checkChangeRequest)
        .then(res => {
          console.log(res);
          if (res.data.object.code == 200) {
            this.approveWindow = true;
            this.signoffComments = "";
          } else {
            this.$confirm(res.data.object.message, this.$t("message.tips.tip"), {
              confirmButtonText: this.$t("message.button.affirm"),
              cancelButtonText: this.$t("message.button.cancel"),
              type: "warning",
            })
              .then(() => {
                this.approveWindow = true;
                this.signoffComments = "";
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: this.$t("message.tips.cancel"),
                });
              });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    approveChange() {

      const url = !this.abc.id ? "/pqm/quality/rejectWorkflow" : "/pqm/quality/approveWorkflow"
      let aaaa = !this.abc.id ? 'rejecters' : 'approvers';
      const users = [{
        ...this.currentInfo,
        type: 1,
      }];

      var approveChangeRequest = {
        //post更改的值
        objectId: { ... this.objectId },
        status: +this.workflowInfo.currentStatusId,
        [aaaa]: users,
        comments: this.signoffComments,
      };
      //console.log(approveChangeRequest);
      axios.post(url, approveChangeRequest)
        .then(res => {
          if (res.data.code == 200) {
            this.approveWindow = false;
            this.$message({
              message: res.data.message,
              type: this.abc.id ? "success" : "error",
            });
            this.updateWorkflowNum += 1;
            this.updateWorkflowTable = this.updateWrokflowNum;
            //this.change_to_child = res.data.object.approveStatusId;
            // this.logoInfo();
            this.$emit('setPageRefresh')
          }
        }).catch(function (error) {
          const title = !this.abc.id ? this.$t("message.error.reject") : this.$t("message.error.approve")
          this.$message.error(title);
          console.log(error);

        });
      this.approveWindow = false;
    },

    checkDelPriv() { },

    addApprover(row) {
      //添加
      if (row) {
        //console.log(this.approvers.length);
        //console.log(row);
        var isDuplicateVal = false;
        for (var j = 0; j < this.approvers.length; j++) {
          //console.log(this.approvers[j]);
          if (row.itemId == this.approvers[j]) {
            isDuplicateVal = true;
            break;
          }
        }
        if (isDuplicateVal) {
          this.$message.error(this.$t("message.error.sameUser"));
        } else {
          // this.reviewersAddList = false;
          let user = {};
          user.value = row.itemId;
          for (var i = 0; i < this.userLists.length; i++) {
            if (this.userLists[i].value == row.itemId) {
              user.label = this.userLists[i].label;
            }
          }
          this.options.push(user);
          this.approvers.push(row.itemId);
          this.$message.success('添加成功')
        }
      }
    },
    addObserver(row) {
      //添加
      if (row) {
        //console.log(this.notify.length);
        //console.log(row);
        var isDuplicateVal = false;
        for (var j = 0; j < this.notify.length; j++) {
          if (row.itemId == this.notify[j]) {
            isDuplicateVal = true;
            break;
          }
        }
        if (isDuplicateVal) {
          this.$message.error(this.$t("message.error.sameUser"));
        } else {
          // this.notifyAddList = false;
          let user = {};
          user.value = row.itemId;
          for (var i = 0; i < this.userLists.length; i++) {
            if (this.userLists[i].value == row.itemId) {
              user.label = this.userLists[i].label;
            }
          }
          this.options2.push(user);
          this.notify.push(row.itemId);
          this.$message.success('添加成功')
        }
      }
    },

    reviewersHandleClose() {
      this.reviewersAddList = false;
    },
    notifyHandleClose() {
      this.notifyAddList = false;
    },
    openSearchApproverWindow() {
      this.reviewersAddList = true;
    },
    openNotifyWindow() {
      this.notifyAddList = true;
    },

    getData() {
      // console.log(this.workflowInfo);
      const obj = {
        statusId: this.workflowInfo.currentStatusId,
        subClassId: this.objectId.subClassId,
      }
      axios.get(`/pmdm/admin/workflow/getNextStatus${this.params(obj)}`).then(res => {
        console.log(res);
        const { currentWorkflowStatus, nextStatus, nextWorkflowStatus, nextWorkflowStatusType } = res.data.object;
        this.StatusBtn = nextStatus.length == 0 || nextWorkflowStatusType < 0;
        this.statusInfo = [...nextStatus];

        this.currentStatus = currentWorkflowStatus;
        this.nextStatus = nextWorkflowStatus;

        this.allInfo = {
          currentStatus: currentWorkflowStatus.id,
          currentStatusType: currentWorkflowStatus.statusType,
          nextStatus: nextWorkflowStatus.id,
          nextStatusType: nextWorkflowStatus.statusType,
          workflowId: currentWorkflowStatus.workflowId
        }
      })
    },
    checkUsrHasARPriv() {
      const obj = { ...this.objectId };
      axios.get(`/pqm/quality/checkUsrHasARPriv${this.params(obj)}`).then(res => {
        this.buttonList.map(i => i.hasPriv = !res.data.object.hasPriv)
      })
    },
    loadUserPriv() {
      const privList = this.getUserContextPriv().filter(i => i.classId == this.objectId.subClassId).map(j => j.type);
      this.addApproverPriv = privList.includes(0) || privList.includes(19);
    },
  },
  mounted() {
    const session = JSON.parse(window.sessionStorage.getItem("userContext"));
    const { id, loginId } = session;
    this.currentInfo = { id, loginId };
    // this.getData();
    this.loadUserPriv();
    this.checkUsrHasARPriv();
  }

}
</script>
<style>
/* .disabled-click .el-button-group button {
  color: #c0c4cc;
  pointer-events: none;
}

.disabled-cursor {
  cursor: not-allowed;
} */
</style>
<style scoped>
.disabled-click {
  color: #c0c4cc;
  pointer-events: none;
}

.disabled-cursor {
  cursor: not-allowed;
}

.tableBtn {
  position: absolute;
  bottom: 0;
  right: 0;
}

.table-list {
  overflow: hidden;
  margin-top: 4px;
}


.table-list .list-key {
  display: inline-block;
  width: 22%;
  text-align: right;
  font-size: 14px;
  line-height: 40px;
  float: left;
}

.table-list .list-val {
  display: inline-block;
  width: 60%;
  overflow: hidden;
}

.list-cc {
  display: inline-block;
  margin: 0 6px;
  line-height: 200px;
  float: left;
}
</style>
